<template>
  <div id="app">
    <v-app>
      <v-content>
        <v-container pl-0 pr-0>
          <v-layout align-center justify-center>
            <v-flex>
              <div id="nav">
                <app-navbar
                  :busyWorker="$store.getters['worker/busy']"
                  :busyInput="busyInput"
                  :workerReady="$store.getters['worker/ready']"
                />
              </div>
              <router-view />
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
      <v-flex>
        <font-awesome-icon :icon="['fas', 'crown']" />
        <a v-bind:href="galllink"> 에스프레소맛 쿠키 갤러리 </a>
          <font-awesome-icon :icon="['fas', 'crown']" />
        <br />
        Based on
        <font-awesome-icon :icon="['fab', 'github']" />
        <a v-bind:href="link"> latsic/imgalign</a>
      </v-flex>
    </v-app>
  </div>
</template>

<script>
import Navbar from "@/components/navigation/Navbar";
import { Logger } from "@/loggers/Logger";
import { paramTypes } from "@/models/constants/params";

export default {
  components: {
    appNavbar: Navbar,
  },
  data: () => ({
    galllink:
      "https://gall.dcinside.com/mgallery/board/lists?id=espressocookie",
    link: "https://github.com/latsic/imgalign",
  }),
  created() {
    this.$store.dispatch("settings/init");
    Logger.init(
      () => this.$store.getters["settings/param"](paramTypes.logInfoEnabled.id),
      () =>
        this.$store.getters["settings/param"](paramTypes.logErrorEnabled.id),
      () =>
        this.$store.getters["settings/param"](paramTypes.logAssertEnabled.id),
      () =>
        this.$store.getters["settings/param"](paramTypes.logExternEnabled.id),
      (msg) => this.$store.commit("logs/addMessage", msg),
      (msg) => this.$store.commit("logs/addErrorMessage", msg),
      (msg) => this.$store.commit("worker/currentActionInfo", msg)
    );
    this.$store.commit("settings/param", { id: 305, value: 561 });
    this.$store.commit("settings/param", { id: 610, value: 612 });
    this.$store.commit("settings/param", { id: 583, value: 701 });
  },
  computed: {
    busyInput() {
      return (
        this.$store.getters["input/busyAny"] ||
        this.$store.getters["multiInput/busy"] ||
        this.$store.getters["multiInput/busyLoading"]
      );
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  /* margin-top: 60px; */
}
a {
    text-decoration: none;
}
html {
  overflow-y: auto;
}
</style>

